var followTypes = {
    user: 'user',
    interest: 'interest'
};

var trackingIds = {
    moduleId: '43604',
    LINK_SAVE_SEARCH: '44571',
    LINK_SAVED_SEARCH: '44561',
    LINK_SAVE_SELLER: '44562',
    LINK_SAVED_SELLER: '44563',
    LINK_FLYOUT_CLOSE_BUTTON: '44564',
    LINK_FLYOUT_DISMISS: '44565',
    LINK_NAME_INPUT_CLICK: '44566',
    LINK_NOTIFICATION_CHECKED: '44567',
    LINK_NOTIFICATION_UNCHECKED: '44568',
    LINK_REMOVE_SEARCH: '44569',
    OVERLAY_SAVE_BUTTON: '49471',
    OVERLAY_CANCEL: '49472',
    OVERLAY_EMAIL_TOGGLE: '49473',
    TOOLTIP_EMAIL_OPT_OUT: '49536'
};

var followActions = {
    follow: 'follow',
    update: 'update',
    unfollow: 'unfollow',
    followExp: 'follow-exp',
    unfollowExp: 'unfollow-exp',
    dismissExp: 'dismiss-exp'
};

var l10nErrorCodes = {
    maxSaved: 'errorMaxedSaveSearch',
    save: 'errorSave',
    unsave: 'errorUnsave'
};

var serverErrors = {
    maxSaved: 'follow_svc.error.maxed_saved_search',
    unreachable: 'follow_svc.error.service_unreachable',
    loginRequired: 'follow_svc.error.login_required'
};

var csrfSelectors = {};
csrfSelectors[followActions.follow] = 'follow';
csrfSelectors[followActions.unfollow] = 'unfollow';
csrfSelectors[followActions.update] = 'update';
csrfSelectors[followActions.followExp] = 'follow-exp';
csrfSelectors[followActions.unfollowExp] = 'unfollow-exp';
csrfSelectors[followActions.dismissExp] = 'dismiss-exp';

var followAjaxEndpoints = {};
followAjaxEndpoints[followActions.follow] = '{SVC_HOST}/follow?{ENTITY_TYPE}{SEARCH_URL}{NAME}{EMAIL}{CSRF}{USER_NAME}';
followAjaxEndpoints[followActions.unfollow] = '{SVC_HOST}/unfollow?{ENTITY_TYPE}{ENTITY_ID}{CSRF}{USER_NAME}';
followAjaxEndpoints[followActions.update] = '{SVC_HOST}/update?{ENTITY_TYPE}{ENTITY_ID}{NAME}{EMAIL}{CSRF}{USER_NAME}';

var helperIds = {
    current: 'follow-ebay-helper',
    legacy: 'follow-ebay-helper-legacy'
};

module.exports = {
    followTypes: followTypes,
    trackingIds: trackingIds,
    followActions: followActions,
    followAjaxEndpoints: followAjaxEndpoints,
    l10nErrorCodes: l10nErrorCodes,
    serverErrors: serverErrors,
    csrfSelectors: csrfSelectors,
    helperIds: helperIds
};
